import React, { Component } from "react"
import PropTypes from "prop-types"

import ConnectButton from "./connect_button"

export default class ConnectedApplet extends Component {
  render() {
    return (
      <ConnectButton
        connectClicked={this.props.connectClicked}
        mainService={this.props.mainService}
        onConnectClick={this.props.onDisconnectClick}
        ctaCopy="Connected"
        programmable={this.props.programmable}
        connected={this.props.appletConnected}
        knobBgColorForDarkBrands={this.props.knobBgColorForDarkBrands}
        connectButtonMaxFontSize={this.props.connectButtonMaxFontSize}
        showKnob
      />
    )
  }
}

ConnectedApplet.propTypes = {
  connectClicked: PropTypes.bool.isRequired,
  appletConnected: PropTypes.bool,
  mainService: PropTypes.object.isRequired,
  programmable: PropTypes.bool,
  onDisconnectClick: PropTypes.func.isRequired,
  knobBgColorForDarkBrands: PropTypes.bool,
  connectButtonMaxFontSize: PropTypes.number,
}
